import { SViewProps } from '.'
import SView from './SView'

export interface Props extends SViewProps {
  vertical?: boolean
}

export default function SDivider({ vertical, ...rest }: Props) {
  return (
    <SView
      borderWidth={1}
      borderColor="rgba(255, 255, 255, 0.10)"
      borderLeftWidth={vertical ? 1 : 0}
      borderRightWidth={0}
      borderBottomWidth={0}
      h={vertical ? '100%' : undefined}
      w={vertical ? undefined : '100%'}
      borderTopWidth={vertical ? 0 : 1}
      {...rest}
    />
  )
}
